export default from './AlertMessage'


// WEBPACK FOOTER //
// ./src/components/Modules/AlertMessage/index.js